<template>
    <div class="map-component">                
        <div class="map" ref="mapDiv"></div>

        <map-legend-container ref="legend"></map-legend-container>
        
        <div v-if="isReadyToInteract" class="map-utils" :style="{ top: (10 + $store.state.toolbarHeight) + 'px' }">
            <button class="map-tool-button btn btn-primary btn-sm" @click="variableButtonClicked">
                <img v-if="selVariable != null" :src="selVariableImageSrc" />
                {{ selVariableName }}
            </button>
            <div class="dropdown" style="display: inline">
                <button class="map-tool-button btn btn-primary dropdown-toggle btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ selMonthName }}</button>
                <div class="dropdown-menu">
                    <a v-for="month in monthList" 
                       :key="month.monthIndex" 
                       :data-monthIndex="month.monthIndex"
                       class="dropdown-item" 
                       :class="{ active: month.monthIndex == selMonthIndex }"
                       href="#"
                       @click="monthIndexMenuItemClicked"
                       >{{ month.name }}</a>
                </div>
            </div>
            <div v-if="layerList.length > 0" class="dropdown" style="display: inline" id="layer-list-dropdown">
                <button class="map-tool-button btn btn-primary dropdown-toggle btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img src="/images/map-toolbar-icons/layers.png" width="20" height="20" />
                </button>
                <div class="dropdown-menu">
                    <a v-for="layer in layerList"
                        :key="layer.layerID"
                        :data-layerId="layer.layerID"
                        class="dropdown-item"
                        :class="{ active: layerSelected(layer.layerID) }"
                        href="#"
                        @click="layerItemClicked">{{ layer.name }}</a>
                </div>
            </div>    
        </div>
    
        
        <div class="mobile-popup-wrapper" ref="mobileUserPointDataWrapper" @click="mobilePopupWrapperClick">
            <div class="mobile-popup-content">
                <user-point-data-view ref="mobileUserPointDataView"></user-point-data-view>
            </div>
        </div>
    </div>    
</template>

<script>
import MapLegend from '@/components/MapLegend.vue'
import UserPointDataView from '@/components/UserPointDataView.vue'

import $ from '@/lib/JQuery.js'
import events from '@/lib/events.js'
import logger from '@/lib/logger.js'
import config from '@/lib/config.js'
import dateUtils from '@/lib/DateUtils.js'
import moment from 'moment'
import UserPoint from '@/lib/UserPoint.js'
import ewpService from '@/lib/ewpService.js'
import { ServiceController } from '@/lib/ServiceController.js'
import RefSysUtils from '@/lib/RefSysUtils.js'

import Vue from 'vue'
import MapLegendContainer from "@/components/MapLegendContainer.vue";

let L = window.L

const zIndexForecastLayer = 10
const zIndexRasterLayer = 50
const zIndexVectorLayer = 100

export default {
    name: 'MapViewer',
    data() {
        return {
            mapControl: null,
            selVariable: null,
            rasterDataLayer: null,
            imageLayer: null,
            selMonthIndex: 0,
            markers: null,
            popupDataViewConstructor: null,
            currentImageLayerUrl: '',
            currentRasterDataLayerUrl: '',
            selectedLayers: [],
            // legendVisible: true
        }
    },
    components: {
      MapLegendContainer,
      UserPointDataView
    },
    methods: {
        // setLegendVisible(visible) {
        //     this.legendVisible = visible
        // },
        forecastChanged() {
            logger.log('MapViewer::forecastChanged()')
            
            this.selVariable = null
                        
            let forecast = this.$store.state.forecast            
            
            let lat = forecast.country.centerY
            let lon = forecast.country.centerX            

            this.panTo([lat, lon])
        },
        getCurrentImageLayerUrl() {
            return this.currentImageLayerUrl || ''
        },
        variableButtonClicked() {
            events.$emit(events.ACTION_OPEN_VARIABLE, this)
        },
        selectVariable(variable) {
            this.selVariable = variable
            this.updateImageLayer()
            this.updateLegend()
        },
        getOrCreateImageOverlay(current, url, bounds, opacity, zIndex) {
          logger.log('getOrCreateImageOverlay', {current, url, bounds, opacity})

          if (current == null) {
            const layer = L.imageOverlay(url, bounds, { opacity, className: 'image-overlay-layer', zIndex })
            layer.addTo(this.mapControl)
            return layer
          }
          else {
            current.setUrl(url)
            current.setBounds(bounds)

            return current
          }
        },
        setRasterDataLayer(url, bounds) {
          logger.log('MapViewer::setRasterDataLayer', { url: url, bounds: bounds })
          this.rasterDataLayer = this.getOrCreateImageOverlay(this.rasterDataLayer, url, bounds, 1, zIndexRasterLayer)
          this.currentRasterDataLayerUrl = url || ''
          return this.rasterDataLayer
        },
        setImageLayerUrl(url, bounds) {
            logger.log('MapViewer::setImageLayerUrl', { url: url, bounds: bounds })
            this.imageLayer = this.getOrCreateImageOverlay(this.imageLayer, url, bounds, this.$store.state.appSettings.layerOpacity, zIndexForecastLayer)
            this.currentImageLayerUrl = url || ''
            return this.imageLayer
        },
        updateImageLayer() {
            logger.log('MapViewer::updateImageLayer()')

            if (this.selVariable == null) {
                logger.log('No variable selected')
                return
            }

            logger.log('Selecting variable', this.selVariable)
            
            let url = this.selVariable.getUrl(this.selMonthIndex, this.$store.state.forecast.forecastID) 
            let bounds = this.selVariable.layerBounds.toLeafletBounds()            

            logger.log('Updating layer', { url: url, bounds: bounds })
            
            this.setImageLayerUrl(url, bounds)
        },
        updateLegend() {
            this.$refs.legend.updateVarItem(this.selVariable)
        },
        monthIndexMenuItemClicked(e) {
            let le = e.target
            let monthIndex = Number(le.dataset.monthindex)
            
            logger.log('Update month index', monthIndex)

            this.selMonthIndex = monthIndex
            this.updateImageLayer()
        },
        layerOpacityChanged() {
            logger.log('MapViewer::layerOpacityChanged()')
            
            if (this.imageLayer == null) {
                logger.log('imageLayer not created')
                return
            }            
            
            this.imageLayer.setOpacity(this.$store.state.appSettings.layerOpacity)            
        },
        map_Clicked(event) {
            logger.log('Map clicked', event)

            if (this.selVariable == null) {
                logger.log('selVariable is null')
                return
            }

            let latlng = event.latlng
            let point = new UserPoint(null, this.$store.state.forecast.country.countryID, latlng.lat, latlng.lng, 'Unsaved')
            let marker = this.addPointMarker(point)
            if (marker != null) 
                this.showMarkerPopup(marker)
        },
        showMarkerPopup(marker) {
            logger.log('MapViewer::showMarkerPopup()', marker)

            let user = this.$store.state.user
            let forecast = this.$store.state.forecast

            if (marker == null) {
                logger.log('marker is null')
                return
            }
            
            if (this.selVariable == null) {
                logger.log('selVariable is null')
                return
            }

            if (user == null) {
                logger.log('User is null')   
                return
            }

            if (forecast == null) {
                logger.log('Forecast is null')
                return
            }

            let useMobilePopup = (window.innerWidth || 1000) < config.mobilePopupThreshold

            let lat = marker.userPoint.lat
            let lon = marker.userPoint.lon

            let popup = marker.popup
            let div = popup.getContent()
            
            let view = null
            if (useMobilePopup) {
                view = this.$refs.mobileUserPointDataView
                view.allowSave = marker.view.allowSave
                view.allowDelete = marker.view.allowDelete
            }                
            else {
                div.appendChild(marker.view.$el)
                view = marker.view
            }

            view.onSave = null
            view.onDiscard = null

            logger.log('Popup status', { popup: popup, popupVue: popup.vueObject, div: div })
            
            view.resetData()            

            if (useMobilePopup)
                $(this.$refs.mobileUserPointDataWrapper).fadeIn()
            else
                popup.openOn(this.mapControl)

            ServiceController.readVarValues(this.selVariable, forecast, lat, lon, (values) => {
                view.updateData(marker.userPoint, forecast, this.selVariable, values, this.$store.state.user.numMonths, this.$store.state.appSettings.showFullHistoricalInPopup)
                if (!marker.userPoint.isSaved()) {
                    view.onSave = this.deletePointMarker
                    view.onDiscard = this.deletePointMarker
                }                    
            })
        },
        markers_Clicked(event) {
            logger.log('Marker clicked', event)

            let marker = event.layer            

            this.showMarkerPopup(marker)            
        },
        mobilePopupWrapperClick() {
            $(this.$refs.mobileUserPointDataWrapper).fadeOut() //this.$refs.mobileUserPointDataWrapper.style.display = 'none'
        },
        deletePointMarker(point) {
            logger.log('MapViewer::deletePointMarer()', point)

            let marker = null

            if (typeof point == 'string')
                marker = this.markers.getLayers().find((marker) => marker.userPoint.id == point)
            else
                marker = this.markers.getLayers().find((marker) => marker.userPoint == point)

            if (marker == null) {
                logger.log('Marker not found')
                return
            }

            logger.log('Removing marker', marker)

            this.markers.removeLayer(marker)
        },
        initMarkerDataView(marker, point) {
            marker.userPoint = point

            let div = document.createElement('div')
            div.classList.add('popup-container')

            let popup = L.popup()
                        .setLatLng([point.lat, point.lon])
                        .setContent(div)            
        
            marker.popup = popup
            
            marker.on('remove', () => { popup.remove() })        
            
            this.markers.addLayer(marker)      
            
            let view = new this.popupDataViewConstructor()            
            view.$mount(div)                    
            marker.view = view            
            
            logger.log('Marker added', marker)
        },
        addPointMarker(point, opts) {
            logger.log('MapViewer::addPointMarker()', point)            

            if (!(point instanceof UserPoint)) {
                logger.log('Invalid point type')
                return
            }

            let marker = L.marker([point.lat, point.lon], opts)

            this.initMarkerDataView(marker, point)
            
            return marker
        },
        handleUserPointsChanged() {
            logger.log('MapViewer::handleUserPointsChanged')
        },
        panTo(latlng) {
            this.mapControl.panTo(latlng)
        },
        refreshUserPoints() {
            logger.log('MapViewer::refreshUserPoints()')

            this.markers.clearLayers()

            if (this.$store.state.userPoints) {
                logger.log('Adding points to map', this.$store.state.userPoints)
                this.$store.state.userPoints.forEach((point) => this.addPointMarker(point))
            }            
        },
        forceMapSizeUpdate() {
            logger.log('MapViewer::forceMapSizeUpdate()')
            setTimeout(() => { this.mapControl.invalidateSize() }, 500)            
        },
        removeExistingRasterDataLayers() {
          logger.log('removeExistingRasterDataLayers', this.selectedLayers)
          this.selectedLayers = this.selectedLayers.filter(l => !l.isRaster)
        },
        addRasterLayer(id, title, subTitle, bounds, url, colors) {
          // this function should be used to add info data layers, not extrendweather forecast layers
          logger.log('MapViewer::addRasterLayer(bounds, url, colors)', { id, bounds, url, colors })

          this.removeExistingRasterDataLayers()

          const topLeft = L.latLng(bounds[1], bounds[0])
          const bottomRight = L.latLng(bounds[3], bounds[2])
          const latLngBounds = L.latLngBounds(topLeft, bottomRight)

          const layer = this.setRasterDataLayer(url, latLngBounds)

          // const newLayer = L.imageOverlay(url, latLngBounds, { /*opacity: this.$store.state.appSettings.layerOpacity,*/ className: 'image-overlay-layer' })
          // newLayer.addTo(this.mapControl)

          const colorItems = []
          let n = 0
          for(let i=0; i < colors.length; i++) {
            const c = colors[i]
            colorItems.push({color:c.color, text:c.label})
          }

          this.selectedLayers.push({
            layerID: id,
            layer: { id, bounds, url, colors },
            layerItem: layer,
            isRaster: true
          })
          this.$refs.legend.updateLegend(title, subTitle, colorItems)
          // this.legendVisible = true
        },
        addGeoJSONDataLayer(layer, data) {
            logger.log('MapViewer::addGeoJSONLayer', data)
            
            let _self = this
            
            let options = {
                pointToLayer(pt, latlon) {
                    logger.log('Creating data layer marker', { pt: pt, latlon: latlon })

                    let userPoint = new UserPoint(null, _self.$store.state.forecast.country.countryID, latlon.lat, latlon.lng, pt.properties['style-name'])
                    let opts = {}
                    if (pt.properties["style-marker"] == "icon") {
                        opts = {
                            icon: L.icon({
                                iconUrl: pt.properties["style-icon-url"],
                                iconSize: pt.properties["style-icon-size"]
                            })
                        }
                    }                                

                    let marker = _self.addPointMarker(userPoint, opts)
                    marker.view.allowDelete = false
                    marker.view.allowSave = false
                },
                zIndex: zIndexVectorLayer
            }
            
            let layerItem = L.geoJSON(data, options)
            layerItem.addTo(this.mapControl)                
            //layerItem.bindPopup((layer) => { return layer.feature.properties["style-name"] })
            this.selectedLayers.push({
              layerID: layer.layerID,
              layer: layer,
              layerItem: layerItem,
              canRemove: true
            })
        },
        addDataLayer(layer) {
            logger.log('Request to add layer', layer)
            if (layer.layerType === 'geojson') {
                if (layer.sourceType === 'data') {
                    let data = JSON.parse(layer.sourceData)                    
                    this.addGeoJSONDataLayer(layer, data)                    
                }
                else if (layer.sourceType === 'url') {
                    var request = new XMLHttpRequest()
                    request.open('GET', layer.sourceData)                    
                    request.send()

                    request.onreadystatechange = (x) => {
                       
                        if (request.readyState === 4 && request.status === 200) {
                            let data = JSON.parse(request.responseText)
                            this.addGeoJSONDataLayer(layer, data)                            
                        }                        
                    }
                }
            }
            else if (layer.layerType === 'raster') {
              if (layer.sourceType === 'data') {
                const rasterInfo = JSON.parse(layer.sourceData)
                this.addRasterLayer(layer.layerID, layer.name, layer.description, rasterInfo.bounds, rasterInfo.url, rasterInfo.legend)
              }
            }
        },
        removeDataLayer(layer) {
            let selLayer = this.getSelectedLayer(layer.layerID)
            if (selLayer != null) {
                if (selLayer.canRemove)
                  selLayer.layerItem.remove()
                else
                  selLayer.layerItem.setUrl('')
                this.selectedLayers = this.selectedLayers.filter(x => x != selLayer)
            }
        },
        toggleLayer(layer) {
            if (this.layerSelected(layer.layerID)) {
              this.removeDataLayer(layer)
              this.updateLegend()
            }
            else
                this.addDataLayer(layer)
        },
        layerItemClicked(sender) {
            let layerid = sender.target.dataset.layerid
            if (layerid != null) {
                let layer = this.$store.state.layerInventory.find(layerid)                
                if (layer != null) {
                    this.toggleLayer(layer)
                }
            }            
        },
        getSelectedLayer(layerID) {
            for(let i = 0; i < this.selectedLayers.length; i++)
                if (layerID == this.selectedLayers[i].layerID)
                    return this.selectedLayers[i]
            return null
        },
        layerSelected(layerID) {
            logger.log('MapViewer::layerSelected()', layerID)
            let layer = this.getSelectedLayer(layerID)
            logger.log('Found layer', layer)
            return (layer != null)
        }
    },
    computed: {
        layerList() {
            logger.log('MapViewer::layerList()')

            let layers = this.$store.state.layerInventory
            if (layers == null)
            {
                logger.log('layers is null')
                return []
            }                
            if (layers.items == null)
            {
                logger.log('layers.items is null')
                return []
            }
            return layers.items
        },
        selVariableImageSrc() {
            if (this.selVariable == null)
                return ''

            return '/images/vartype-icons/' + this.selVariable.varType + '.png'
        },
        selVariableName() {
            if (this.selVariable == null)
                return 'Select Variable'
            
            return this.selVariable.name
        },
        isVarSelected() {
            return this.$store.state.forecast != null && this.selVariable != null
        },
        isReadyToInteract() {
            return this.$store.state.forecast != null &&
                   this.$store.state.forecastVarInventory != null
        },
        selMonthName() {
            logger.log('MapViewer::selMonthName()')

            let forecast = this.$store.state.forecast
            
            if (forecast == null)
                return 'Month'

            let date = forecast.forecastID.getFirstForecastDate()
            logger.log('Updating date', { date: date.toString(), byMonths: this.selMonthIndex })
            
            date = dateUtils.addMonths(date, this.selMonthIndex)
            logger.log('Date updated', date.toString())

            let s =  moment(date).format('MMMM')

            return s
        },
        monthList() {
            let list = []

            let forecast = this.$store.state.forecast

            if (forecast != null) {
                let date = forecast.forecastID.getFirstForecastDate()
                for (let i=0; i < this.$store.state.user.numMonths; i++) {
                    list.push({ 
                        monthIndex: i, 
                        name: moment(date).format('MMMM') 
                    })
                    date = dateUtils.addMonths(date, 1)
                }
            }

            return list
        }        
    },
    mounted() {
        events.$on(events.EVT_FORECAST_CHANGED, () => this.forecastChanged())
        events.$on(events.EVT_LAYER_OPACITY_CHANGED, () => this.layerOpacityChanged())
        events.$on(events.EVT_POINT_ADDED, (point) => this.addPointMarker(point))
        events.$on(events.EVT_USER_POINTS_CHANGED, () => this.handleUserPointsChanged())
        events.$on(events.ACTION_PAN_TO, (latlng) => this.panTo(latlng))
        events.$on(events.EVT_USER_POINTS_CHANGED, () => this.refreshUserPoints())
        events.$on(events.EVT_DUAL_PANE_CHANGED, () => this.forceMapSizeUpdate())
        events.$on(events.EVT_POINT_DELETED, (pointID) => this.deletePointMarker(pointID))

        this.mapControl = L.map(this.$refs.mapDiv, {
            center: [0, 0],
            zoom: 7,
            zoomSnap: 0,
            zoomDelta: 0.25,
            wheelPxPerZoomLevel: 100
        })

        this.mapControl.on('click', (event) => this.map_Clicked(event))        
        this.markers = L.featureGroup().addTo(this.mapControl)
        this.markers.on('click', (event) => this.markers_Clicked(event))

        this.popupDataViewConstructor = Vue.extend(UserPointDataView)

        this.mapControl.zoomControl.setPosition('bottomright')

        L.tileLayer('https://api.mapbox.com/styles/v1/matthewcs/ckc2l5pe406y91jl9m0p590ui/tiles/{z}/{x}/{y}?access_token={accessToken}', {
            attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
            maxZoom: 18,
            accessToken: config.mapBoxAccessToken
        }).addTo(this.mapControl);           
    }
}
</script>

<style>
    .map {
        border: 1px solid rgb(45, 85, 173, 0.5);
    }

    .map-component, .map {
        position: relative;        
        width: 100%;
        height: 100%;
        padding-top: 0;
    }

    .map-utils {
        position: absolute;
        left: 10px;
        top: 68px;        
        z-index: 401;
        transition: top 0.5s;
    }

    .map-legend-container {
        position: absolute;
        left: 10px;
        bottom: 10px;
        padding: 0.7em;
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 4px;
        z-index: 401;
        max-width: 200px;
        border: 1px solid rgb(0, 0, 0, 0.1)
    }

    .map-tool-button {
        margin-right: 0.5em;
        min-height: 24px;
    }

    .image-overlay-layer {
        image-rendering: pixelated;
        image-rendering: -moz-crisp-edges;
        image-rendering: crisp-edges;
    }

    .popup-container {
        padding: 4px;
        min-width: 300px;
    }

    .mobile-popup-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 1500;
        background-color: #333;
        background-color: rgba(33, 33, 33, 0.6);
        display: none;
    }

    .mobile-popup-content {
        position: absolute;
        left: 30px;
        top: 30px;
        right: 30px;
        bottom: 30px;
        background-color: white;
        overflow-y: auto;
        border-radius: 10px;
        padding: 15px;
    }    

    .dropdown-menu {
        z-index: 2000;
    }

    .leaflet-right {
        max-width: 70% !important;
    }

</style>
